// extracted by mini-css-extract-plugin
export default {"label":"SpeakingTo_label__bFl42"};